module.exports = __webpack_public_path__ + "img/laitages.5faaad99.png";